import { PACSCommunication } from 'app/interfaces/PACSCommunication';
import React from 'react';

export const PACSCommunicationContext = React.createContext<PACSCommunication>(undefined);
